import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref } from "@nuxtjs/composition-api";
import type { HomeTempHarborItem } from "~/services/model/product";
import type { SwiperOptions } from 'swiper'

// @ts-ignore
import DES_BG_IMG from '@/assets/img/home/des-bg.png'

import VResponsive from '~/components/VResponsive/VResponsive.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleHarbor',
  props: {
    title: null,
    items: null
  },
  setup(__props: any) {



const swiperComponentRef = ref();
const swiperComponentinstance = computed(
  () => swiperComponentRef.value?.$swiper
);
const swiperOptions:SwiperOptions = {
  slidesPerView: 4,
  spaceBetween: 24,
  navigation: {
    nextEl: ".j_next",
    prevEl: ".j_prev",
  },
  on: {
    // reachBeginning: () => state.isBeginning = true,
    slideChange() {
      Object.assign(state, {
        isBeginning: this.isBeginning,
        isEnd: this.isEnd,
      });
    },
  },
};

const state = reactive({
  isBeginning: true,
  isEnd: false,
});
const onNext = () => swiperComponentinstance.value?.slideNext();
const onPrev = () => swiperComponentinstance.value?.slidePrev();

return { __sfc: true,swiperComponentRef, swiperComponentinstance, swiperOptions, state, onNext, onPrev, DES_BG_IMG, VResponsive }
}

})